import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { formatTargetRate, formatThreshold } from '@/shared/lib/utils';
import { StatTile } from '@/shared/ui';

type Props = {
  /** Всего диалогов в выборке */
  totalDialogs: number;
  /** Доля цели по всей выборке (0..1) или null */
  baselineRate: number | null;
  /** Выбрана ли целевая метрика: без неё базовая доля цели не показывается */
  isTargetSelected: boolean;
  /** Текущий порог близости */
  threshold: number;
  /** Число кластеров текущего среза */
  clusters: number;
};

/**
 * Строка KPI «Иерархии понятий»: объём выборки, базовая доля цели по всей
 * выборке (как в матрице), текущий порог и число кластеров.
 *
 * Базовая доля цели показывается только при выбранной целевой метрике: без неё
 * бэкенд молча считает целью удержание, и карточка выдавала бы долю удержания
 * за «базовую долю цели», которой пользователь не задавал.
 */
export const HierarchyKpi: FC<Props> = ({ totalDialogs, baselineRate, isTargetSelected, threshold, clusters }) => {
  const { t } = useTranslation('strategist');

  return (
    <div
      className={cn('grid grid-cols-1 sm:grid-cols-2 gap-3', isTargetSelected ? 'lg:grid-cols-4' : 'lg:grid-cols-3')}
    >
      <StatTile label={t('hierarchy.kpi.totalDialogs')}>{totalDialogs.toLocaleString()}</StatTile>
      {isTargetSelected && <StatTile label={t('hierarchy.kpi.baseline')}>{formatTargetRate(baselineRate)}</StatTile>}
      <StatTile label={t('hierarchy.kpi.threshold')}>{formatThreshold(threshold)}</StatTile>
      <StatTile label={t('hierarchy.kpi.clusters')}>{clusters.toLocaleString()}</StatTile>
    </div>
  );
};
